<template>
    <div class="container">
        <div class="head">
            <div class="head_top">
                <img src="../assets/images/R+logo.png" alt="">
                <p>
                    <img src="../assets/images/tel.png" alt="">
                    0571-56638573
                </p>
            </div>
            <div class="head_bottom">
                <div>
                    <img src="../assets/images/rujia_3.png" alt="">
                    <img src="../assets/images/rujia_4.png" alt="">
                </div>
                <p>专注于泛时尚IP打造和商业化运作</p>
                <p>业务主旨孵化、培养优质时尚内容，为全球新零售品牌客户提供多元化的整合营销方案</p>
                <!-- <div>点击进入</div> -->
            </div>
        </div>
        <div class="bg_c_f">
            <div class="main_item">
                <p>签约达人</p>
                <div class="main_item_content">
                    <el-carousel height="499px" :autoplay="true" :interval="5000" indicator-position="none">
                        <el-carousel-item>
                            <div class="carousel-item">
                                <img src="../assets/images/daren_1.png" alt="">
                                <!-- <el-image src="https://wxgroup-img.duomai.com/FiHCZXjcnTmQ7QWWfZuNYKE7C_hu" lazy></el-image> -->
                                <p>E锅锅</p>
                                <div></div>
                                <p>B站知名时尚UP主：主攻日常、创意妆容和古风妆容，粉丝心目中的“全能型美妆博主”</p>
                            </div>
                            <div class="carousel-item">
                                <img src="../assets/images/daren_2.png" alt="">
                                <!-- <el-image src="https://wxgroup-img.duomai.com/FtMtvMeH62lgggxmlAiACbiGGBix" lazy></el-image> -->
                                <p>白光组合</p>
                                <div></div>
                                <p>互动内容创作者：韩国人在中国。会唱歌、会跳舞、会弹吉他、耍的了帅，卖的了萌、逗的了比。</p>
                            </div>
                            <div class="carousel-item">
                                <img src="../assets/images/daren_3.png" alt="">
                                <!-- <el-image src="https://wxgroup-img.duomai.com/FlMZSWpe0psP262_B-XBcmo-K-YC" lazy></el-image> -->
                                <p>草匠匠匠匠</p>
                                <div></div>
                                <p>时尚、技术全能型UP主：编导出身，时尚敏锐度高，视频质量过硬。亲和力超强、粉丝粘性极高的邻家大姐姐.</p>
                            </div>
                            <div class="carousel-item">
                                <img src="../assets/images/daren_4.png" alt="">
                                <!-- <el-image src="https://wxgroup-img.duomai.com/Fgxvpj5N7R3BtPiHrplzfX03goQW" lazy></el-image> -->
                                <p>eLKO表哥</p>
                                <div></div>
                                <p>欧美彩妆大神，有模特化妆师经验。视频内容以创意彩妆教程、明星仿妆、美妆测评为主，风格大胆前卫又不失幽默。</p>
                            </div>
                        </el-carousel-item>
                        <el-carousel-item>
                            <div class="carousel-item">
                                <img src="../assets/images/daren_5.png" alt="">
                                <!-- <el-image src="https://wxgroup-img.duomai.com/FmndfZT3tCO0p2DRZ8A_Hw4DXb3_" lazy></el-image> -->
                                <p>白兰花Michelia</p>
                                <div></div>
                                <p>作者：白小姐，写有温度、有力量的文字。愿与你分享有意思有意义的生活，与你一起独立和改变。</p>
                            </div>
                            <div class="carousel-item">
                                <img src="../assets/images/daren_6.png" alt="">
                                <!-- <el-image src="https://wxgroup-img.duomai.com/FhekJL3nB4f7FG--W8QtcY7Oz6dr" lazy></el-image> -->
                                <p>仙爷种草机</p>
                                <div></div>
                                <p>时尚编辑仙爷，能man能魅的大女子，真人体验勇敢测评，为你寻找时尚好物，这一口种草你值得拥有。</p>
                            </div>
                            <div class="carousel-item">
                                <img src="../assets/images/daren_7.png" alt="">
                                <!-- <el-image src="https://wxgroup-img.duomai.com/FvSVAcppcKEteeKd758qFyqE4-yt" lazy></el-image> -->
                                <p>Lin张林超</p>
                                <div></div>
                                <p>女性时尚专家，Lin Edition Limit女装品牌创始人，带你一起研究时尚，驾驭时尚，做一个时尚的女人！</p>
                            </div>
                            <div class="carousel-item">
                                <img src="../assets/images/daren_8.png" alt="">
                                <!-- <el-image src="https://wxgroup-img.duomai.com/Fl3bjy5boRQ8xdwSC58IjIHEzo5O" lazy></el-image> -->
                                <p>麦琪啦啦啦</p>
                                <div></div>
                                <p>哈佛女研究生，是投资人也是淘宝店主，风格毒舌、直率。</p>
                            </div>
                        </el-carousel-item>
                        <el-carousel-item>
                            <div class="carousel-item">
                                <img src="../assets/images/daren_9.png" alt="">
                                <!-- <el-image src="https://wxgroup-img.duomai.com/FoDIhyqZIYFO4jHU_Qvw4sE-oHws" lazy></el-image> -->
                                <p>十六铺双生花</p>
                                <div></div>
                                <p>创意情景演绎型内容创作者：主攻情景演绎方向的内容创作者。妇女之友、观众缘极好、脑洞无限大。</p>
                            </div>
                            <div class="carousel-item">
                                <img src="../assets/images/daren_10.png" alt="">
                                <!-- <el-image src="https://wxgroup-img.duomai.com/FunihRrXbsAOT-DXJkUOSLozBVmE" lazy></el-image> -->
                                <p>颠点儿_</p>
                                <div></div>
                                <p>男性时尚up主：飞速成长的男性时尚自媒体博主.美妆、穿搭…全能型内容创作者。</p>
                            </div>
                            <div class="carousel-item">
                                <img src="../assets/images/daren_11.png" alt="">
                                <!-- <el-image src="https://wxgroup-img.duomai.com/FnDcrQFbCfse5Af5gGArRAmvOlFa" lazy></el-image> -->
                                <p>刘小呆</p>
                                <div></div>
                                <p>网红土拨鼠：萌宠KOL，全网爆红的土拨鼠二柴与二蛋。内容以日常、剧场、科普为主。</p>
                            </div>
                        </el-carousel-item>
                    </el-carousel>
                </div>
            </div>
            <div class="main_item">
                <p>广告形式</p>
                <div class="main_item_content">
                    <div class="main_item_content_ad">
                        <div class="ad_item">
                            <div class="ad_item_hover_shadow"></div>
                            <!-- <p>热销营销</p> -->
                            <div class="ad_item_content">
                                <p>热销营销</p>
                                <p>结合社会热点与产品特性定制品牌推广内容</p>
                            </div>
                        </div>
                        <div class="ad_item">
                            <div class="ad_item_hover_shadow"></div>
                            <div class="ad_item_content">
                                <p>销售引流</p>
                                <p>依托广告内容，配合导购链接直接带动销售链接导流至品牌官方销售渠道或红人自有店铺</p>
                            </div>
                        </div>
                        <div class="ad_item">
                            <div class="ad_item_hover_shadow"></div>
                            <div class="ad_item_content">
                                <p>微电影</p>
                                <p>以红人为主角，具有完整故事情节的短时小电影</p>
                            </div>
                        </div>
                    </div>
                    <div class="main_item_content_ad">
                        <div class="ad_item">
                            <div class="ad_item_hover_shadow"></div>
                            <div class="ad_item_content">
                                <p>植入软广</p>
                                <p>将产品植入红人日常专栏进行软性曝光，一般分为爱用物分享，开箱，化妆教程等主题</p>
                            </div>
                        </div>
                        <div class="ad_item">
                            <div class="ad_item_hover_shadow"></div>
                            <div class="ad_item_content">
                                <p>品牌联名</p>
                                <p>品牌借助红人的专业度和影响力，与红人共同打造联名产品</p>
                            </div>
                        </div>
                        <div class="ad_item">
                            <div class="ad_item_hover_shadow"></div>
                            <div class="ad_item_content">
                                <p>线下活动</p>
                                <p>红人出席品牌线下活动如新品发布会，时装周，快闪店等形式</p>
                            </div>
                        </div>
                    </div>
                    <div class="main_item_content_ad">
                        <div class="ad_item">
                            <div class="ad_item_hover_shadow"></div>
                            <div class="ad_item_content">
                                <p>定制软广</p>
                                <p>针对品牌诉求，制定品牌专属的推广内容</p>
                            </div>
                        </div>
                        <div class="ad_item">
                            <div class="ad_item_hover_shadow"></div>
                            <div class="ad_item_content">
                                <p>附增值服务</p>
                                <p>根据用户属性将推广内容精准投放给目标人群的营销服务</p>
                            </div>
                        </div>
                        <div class="ad_item">
                            <div class="ad_item_hover_shadow"></div>
                            <div class="ad_item_content">
                                <p>TVC</p>
                                <p>红人拍摄官方性质的广告短片，时长在10-60分钟</p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="main_item">
                <p>核心优势</p>
                <div class="main_item_content">
                    <div class="main_item_content_advantage">
                        <img src="../assets/images/hx_1.png" alt="">
                        <div>
                            <p>达人经济优势</p>
                            <p>结合达人特点提供专业经纪服务，量身定制达人发展规划，建立完善的成长体系。</p>
                        </div>
                    </div>
                    <div class="main_item_content_advantage">
                        <img src="../assets/images/hx_2.png" alt="">
                        <div>
                            <p>商业价值最大化</p>
                            <p>抖音、微博等平台战略合作伙伴，通过多平台流量聚合，实现红人商业价值最大化。</p>
                        </div>
                    </div>
                    <div class="main_item_content_advantage">
                        <img src="../assets/images/hx_3.png" alt="">
                        <div>
                            <p>全方位营销服务</p>
                            <p>为品牌定制深洞察、易传播、强互动的创意内容， 以social化广告为品牌提供从形象传播到销售转化的全方位营销服务。</p>
                        </div>
                    </div>
                    <div class="main_item_content_advantage">
                        <img src="../assets/images/hx_4.png" alt="">
                        <div>
                            <p>聚焦时尚领域 </p>
                            <p>聚焦深耕时尚领域人群，集中火力在时尚领域内制造大声量传播。</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bg_c_b">
            <div class="main_item">
                <p>合作伙伴</p>
                <div class="main_item_content">
                    <img src="../assets/images/hzhb.png" alt="">
                </div>
            </div>
        </div>
        <div class="top" v-show="isShow" @click="goToTop"></div>
        <foot-cpright></foot-cpright>
    </div>
</template>

<script>
import footCpright from '../components/foot-cpright.vue'
export default {
    data() {
        return {
            isShow: false
        }
    },
    components: { footCpright },
    mounted() {
        window.addEventListener('scroll', this.scrollToTop)
    },
    methods: {
        scrollToTop() {
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            this.scrollTop = scrollTop
            if (scrollTop > 100) {
                this.isShow = true;
            } else {
                this.isShow = false;
            }
        },
        goToTop() {
            document.documentElement.scrollTop = document.body.scrollTop = 0
            // this.interval = setInterval(() => {
            //     let isSpeed = Math.floor(-this.scrollTop / 3)
            //     document.documentElement.scrollTop = document.body.scrollTop = this.scrollTop + isSpeed
            //     if (this.scrollTop == 0) {
            //         clearInterval(this.interval)
            //     }
            // }, 100)
        }
    },
    destroyed() {
        window.removeEventListener('scroll', this.scrollToTop);
    }
}
</script>

<style lang="scss" scoped>
.container {
    min-width: 1280px;
    position: relative;
    & .head {
        height: 754px;
        background-image: url("../assets/images/im_bg.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        & > div {
            width: 1200px;
        }
        & .head_top {
            height: 110px;
            & > img {
                display: inline-block;
            }
            & > p {
                height: 110px;
                float: right;
                display: flex;
                align-items: center;
                font-size: 16px;
                color: #ffffff;
                & > img {
                    display: inline-block;
                    margin-right: 10px;
                }
            }
        }

        & .head_bottom {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-top: 120px;
            & > div:nth-child(1) {
                width: 860px;
                height: 195px;
                position: relative;
                & > img {
                    display: block;
                }
                & > img:nth-child(1) {
                    animation: head_img_left_enter 2s;
                }
                & > img:nth-child(2) {
                    animation: head_img_right_enter 2s;
                }
            }
            & > p:nth-child(2) {
                font-size: 40px;
                color: #feffff;
                letter-spacing: 0;
                text-align: center;
                padding-top: 64px;
            }
            & > p:nth-child(3) {
                font-size: 18px;
                color: #ffffff;
                letter-spacing: 0;
                padding: 16px 0 40px;
            }
            & > div:nth-child(4) {
                width: 155px;
                height: 48px;
                text-align: center;
                line-height: 48px;
                border: 1px solid #ffffff;
                border-radius: 26px;
                font-size: 18px;
                color: #fff;
                box-sizing: border-box;
            }
        }
    }
    .bg_c_f {
        background-color: #fff;
        padding-bottom: 80px;
        & .main_item > p {
            color: #1f1f1f;
        }
    }

    .bg_c_b {
        background-color: #3b5adc;
        & .main_item > p {
            color: #fff;
        }
    }
    & .main_item {
        width: 1200px;
        margin: 0 auto;
        padding-top: 80px;
        & > p {
            font-size: 32px;
            letter-spacing: 0;
            padding-bottom: 50px;
            text-align: center;
        }
        & .main_item_content {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: center;
            //签约达人
            & /deep/.el-carousel {
                width: 100%;
                & .el-carousel__item {
                    display: flex;
                    & .carousel-item {
                        width: 270px;
                        height: 499px;
                        border: 1px solid #e4e4e4;
                        border-radius: 137.5px;
                        box-sizing: border-box;
                        padding-top: 25px;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        & > p:nth-child(2) {
                            font-size: 24px;
                            color: #1f1f1f;
                            letter-spacing: 0;
                            text-align: center;
                            padding-top: 32px;
                        }
                        & > div:nth-child(3) {
                            width: 225px;
                            height: 1px;
                            background-color: #e4e4e4;
                            margin: 16px 0;
                        }
                        & > p:nth-child(4) {
                            width: 210px;
                            font-size: 16px;
                            color: #666666;
                            letter-spacing: 0;
                            line-height: 24px;
                            text-align: center;
                        }
                    }
                    & .carousel-item:nth-child(1),
                    & .carousel-item:nth-child(2),
                    & .carousel-item:nth-child(3) {
                        margin-right: 40px;
                    }
                }
                & .el-carousel__arrow {
                    width: 48px;
                    height: 48px;
                    font-size: 20px;
                }
            }

            //广告形式
            & .main_item_content_ad {
                width: 350px;
                & .ad_item {
                    position: relative;
                    & > .ad_item_hover_shadow {
                        width: 100%;
                        height: 100%;
                        opacity: 0.7;
                        background: #4a19d2;
                        display: none;
                    }
                    & > .ad_item_content {
                        width: 275px;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        color: #ffffff;
                        & > p:nth-child(1) {
                            font-size: 24px;
                            text-align: center;
                        }
                        & > p:nth-child(2) {
                            font-size: 16px;
                            display: none;
                        }
                    }
                }
                & .ad_item:hover {
                    & > .ad_item_hover_shadow {
                        display: block;
                        animation: ad_content_shadow_hover 1s;
                    }
                    & > .ad_item_content {
                        & > p:nth-child(1) {
                            margin-bottom: 10px;
                            animation: ad_content_txt_hover 4s;
                        }
                        & > p:nth-child(2) {
                            display: block;
                            animation: ad_content_txt_hover 4s;
                        }
                    }
                }
            }
            & .main_item_content_ad:nth-child(1) {
                margin-right: 20px;
                padding-top: 68px;
                & > .ad_item:nth-child(1) {
                    height: 170px;
                    margin-bottom: 20px;
                    background-image: url("../assets/images/gg_1.png");
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                }
                & > .ad_item:nth-child(2) {
                    height: 240px;
                    margin-bottom: 20px;
                    background-color: #9fd2b6;
                }
                & > .ad_item:nth-child(3) {
                    height: 254px;
                    background-image: url("../assets/images/gg_4.png");
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                }
            }

            & .main_item_content_ad:nth-child(2) {
                margin-right: 20px;
                & > .ad_item:nth-child(1) {
                    height: 300px;
                    margin-bottom: 24px;
                    background: #fbbd69;
                }
                & > .ad_item:nth-child(2) {
                    height: 255px;
                    margin-bottom: 20px;
                    background-image: url("../assets/images/gg_3.png");
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                }
                & > .ad_item:nth-child(3) {
                    height: 260px;
                    background: #96b8f0;
                }
            }
            & .main_item_content_ad:nth-child(3) {
                padding-top: 68px;
                & > .ad_item:nth-child(1) {
                    height: 170px;
                    margin-bottom: 20px;
                    background-image: url("../assets/images/gg_2.png");
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                }
                & > .ad_item:nth-child(2) {
                    height: 240px;
                    margin-bottom: 20px;
                    background: #f9b2c7;
                }
                & > .ad_item:nth-child(3) {
                    height: 255px;
                    background-image: url("../assets/images/gg_5.png");
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                }
            }
            //核心优势
            & .main_item_content_advantage {
                width: 580px;
                height: 131px;
                box-sizing: border-box;
                background: #ffffff;
                border: 1px solid #e4e4e4;
                padding: 20px;
                cursor: pointer;
                display: flex;
                & > img {
                    width: 44px;
                    height: 44px;
                }
                & div {
                    flex: 1;
                    padding-left: 20px;
                    & > p:nth-child(1) {
                        font-size: 24px;
                        color: #1f1f1f;
                        letter-spacing: 0;
                        padding-bottom: 10px;
                    }
                    & > p:nth-child(2) {
                        font-size: 16px;
                        color: #666666;
                        letter-spacing: 0;
                        line-height: 24px;
                    }
                }
            }
            & .main_item_content_advantage:hover {
                box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.1);
            }
            & .main_item_content_advantage:nth-child(1),
            & .main_item_content_advantage:nth-child(2) {
                margin-bottom: 40px;
            }
            & .main_item_content_advantage:nth-child(1),
            & .main_item_content_advantage:nth-child(3) {
                margin-right: 40px;
            }
            //合作伙伴
            & > img {
                margin-bottom: 80px;
            }
        }
    }
    & .top {
        width: 60px;
        height: 60px;
        position: fixed;
        right: 83px;
        bottom: 100px;
        background-image: url("../assets/images/Top .png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        z-index: 1000;
    }
    & .top:hover {
        background-image: url("../assets/images/Top_hover.png");
    }
}

@keyframes head_img_left_enter {
    0% {
        opacity: 0;
        transform: translateX(-1030px);
    }
    100% {
        opacity: 1;
        transform: translateX(0);
    }
}
@keyframes head_img_right_enter {
    0% {
        opacity: 0;
        transform: translateX(1030px);
    }
    100% {
        opacity: 1;
        transform: translateX(0);
    }
}

@keyframes ad_content_shadow_hover {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 0.7;
    }
}
@keyframes ad_content_txt_hover {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
</style>